/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */


export enum AccountScheme {
    DXA_CLIENT_USER_ID = 'dxa_client_user_id',
}